import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from "react-router-dom";
import { PropsWithChildren } from 'react';
import { useStores } from "../../stores";
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react-lite';

interface Props {
    id: string;
    to: string;
    text: string;
}

export default observer((props: PropsWithChildren<Props>) => {
    const { panelStore } = useStores();

    const handleClick = () => {
        if (isMobile) {
            panelStore.setCollapsed(true);
        }
    };

    return (
        <ListItemButton
            id={props.id}
            component={Link}
            to={props.to}
            onClick={handleClick}
        >
            <ListItemIcon>
                {props.children}
            </ListItemIcon>
            <ListItemText primary={props.text} />
        </ListItemButton>
    )
});